import React from 'react'

interface CheckIconProps {
  width?: number
  height?: number
  color?: string
}

const CheckIcon: React.FC<CheckIconProps> = ({
  width = 12,
  height = 12,
  color = 'currentColor',
}) => (
  <div
    className="inline-flex items-center justify-center bg-gray-200 rounded-full"
    style={{ width, height }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width * 0.8}
      height={height * 0.8}
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 6L9 17l-5-5" />
    </svg>
  </div>
)

export default CheckIcon
